/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateOrganisationAiSettingsDataSchema = z.object({
	aiPiiEnabled: z.boolean(),
})

export type UpdateOrganisationAiSettingsDataSchema = z.infer<typeof updateOrganisationAiSettingsDataSchema>
